import { z } from "zod";

const optionalId = z.coerce.number().int().positive().optional().catch(undefined);
const columnFilters = z
	.array(z.object({ id: z.string(), value: z.unknown() }))
	.optional()
	.catch(undefined);

export const portalUsageSearchSchema = z.object({
	days: z.coerce
		.number()
		.pipe(z.union([z.literal(7), z.literal(30), z.literal(90)]))
		.default(30)
		.catch(30),
	includeSuperAdmin: z.preprocess(
		(value) => value === true || value === "true",
		z.boolean().default(false).catch(false),
	),
	groupId: optionalId,
	role: z.string().max(100).optional().catch(undefined),
	userId: optionalId,
	view: z.enum(["overview", "audience", "summary"]).default("overview").catch("overview"),
	/** Brak = wymiar wyliczany z danych (`effectiveDimension`): role, gdy grup jest za mało. */
	dimension: z.enum(["groups", "roles", "users"]).optional().catch(undefined),
	metric: z.enum(["views", "time", "adoption"]).default("views").catch("views"),
	/** Tryb mapy portalu: kafle modułów albo proporcje (treemap). */
	mapView: z.enum(["tiles", "treemap"]).default("tiles").catch("tiles"),
	/** Pokaż na mapie pozycje menu bez zbudowanej strony. */
	unavailable: z.preprocess(
		(value) => value === true || value === "true",
		z.boolean().default(false).catch(false),
	),
	module: z.string().max(100).optional().catch(undefined),
	moduleFilters: columnFilters,
	audienceFilters: columnFilters,
});

export type PortalUsageSearch = z.infer<typeof portalUsageSearchSchema>;
